import { useState } from 'react'

import { ACCORDION_FEATURES } from '@/constants/farmerSolutions'

import Picture from '../picture'
import AccordionItem from './AccordionItem'

const DesktopSolutionList = () => {
  const [expandedIndex, setExpandedIndex] = useState(0)

  const onToggle = (index: number) => {
    setExpandedIndex(index)
  }

  return (
    <section className="md:flex hidden">
      <section className="md:w-1/2">
        {ACCORDION_FEATURES.map(({ heading, description, icon }, index) => (
          <AccordionItem
            key={heading}
            heading={heading}
            icon={icon}
            description={description}
            isExpanded={expandedIndex === index}
            onToggle={() => onToggle(index)}
          />
        ))}
      </section>
      <section className="md:w-1/2 md:flex hidden justify-center pt-6 relative">
        {ACCORDION_FEATURES.map(({ image, imageAlt }, index) => (
          <Picture
            image={image}
            imageAlt={imageAlt}
            imageStyle={`sticky top-0 left-0 transition-opacity duration-500 ${
              expandedIndex === index
                ? 'opacity-100 visible max-h-[83vh]'
                : 'opacity-0 invisible h-0'
            }`}
            key={image}
          />
        ))}
      </section>
    </section>
  )
}

export default DesktopSolutionList
